import { saveAs } from 'file-saver';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { FinalizarRecadastramentoService } from 'app/service/finalizar-recadastramento';
import { RelatorioService } from 'app/service/relatorio.service';
import { ToastrService } from 'ngx-toastr';
import { ModalComponent } from '../modal/modal.component';
import { OutroVinculoService } from 'app/service/outro.vinculo';

@Component({
  selector: 'app-recadastramento-aba15',
  templateUrl: './recadastramento-aba15.component.html',
  styleUrls: ['./recadastramento-aba15.component.sass']
})
export class RecadastramentoAba15Component implements OnInit {

  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  user: DadosPessoaisAba1Response = null
  formVinculo: FormGroup;

  isLoadingSpinner: boolean = false
  checkboxMarcado: boolean = false;

  constructor(private finalizarRecadastramentoService: FinalizarRecadastramentoService,
              private relatorioService: RelatorioService,
              private toastrService: ToastrService,
              public dialog: MatDialog,
              private router: Router,
              private formBuilder: FormBuilder,
              private outroVinculoService: OutroVinculoService,
    
    ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.formVinculo = this.formBuilder.group({
      declaracao: [false, Validators.requiredTrue]
    });
               }

  ngOnInit(): void {

  }

  isCheckboxMarcado() {
    return this.formVinculo.get('declaracao').value;
  }


  finalizarRecadastramento() {
    this.isLoadingSpinner = true
    this.finalizarRecadastramentoService.finalizarRecadastramento().subscribe(() => {
      this.toastrService.success('Recadastramento finalizado com sucesso!')

      this.relatorioService.gerarRelatorio('relatorioComprovanteRecadastramento').subscribe((resp: Blob) => {
        let blob: Blob;
        const fileType = resp.type || 'application/octet-stream';

        let fileName = 'Conclusão_Recadastramento'
        const fileExtension = this.getFileExtensionFromMimeType(fileType);

        if (fileExtension) {
          fileName += '.' + fileExtension;
        }

        blob = new Blob([resp], { type: fileType });
        this.downloadFile(blob, fileName);
        this.isLoadingSpinner = false
        this.router.navigate([''])
      })
    })
  }

  private getFileExtensionFromMimeType(mimeType: string): string | null {
    const extensionMap = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpeg',
      'image/jpg': 'jpg',
      'image/png': 'png'
    };

    return extensionMap[mimeType] || null;
  }

  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toastrService.success('Arquivo baixado com sucesso');
  }


  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Atenção!',
        descricao: 'Após a finalização nenhuma alteração será permitida. Deseja realmente continuar?',
        labelOne: 'Não',
        labelTwo: 'Sim',
        action: () => {
          this.finalizarRecadastramento()
        }
      }
    });
  }

  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

}
